export const tableViewRoutes = {
    components: '/components',
    'component-invlevels-history': '/components/history',
    'production-orders': '/assembly',
    'fulfillment-orders/table': '/fulfillment_orders',
    fulfillments: '/fulfillments',
    warranties: '/warranties',
    products: '/products',
    shipments: '/shipments',
    'purchase-orders': '/purchase_orders',
    profiles: '/profiles',
    'shopify/products': '/products/shopify',
    'shopify/product-variants': '/products/shopify/variants',
    'retailer-invoices': '/retailer_invoices',
    retailers: '/retailers',
    'retailer-estimates': '/retailer_estimates',
}

export function tableViewNavigationUrl(view, currentLocation) {
    const path = tableViewRoutes[view.table_key]
    if (!path) return null
    const configuration = view.configuration
    const params = new URLSearchParams({ viewId: String(view.id) })
    for (const [key, value] of Object.entries(configuration.filters ?? {})) {
        if (value != null && value !== '' && (!Array.isArray(value) || value.length)) {
            params.set(key, Array.isArray(value) ? value.join(',') : String(value))
        }
    }
    params.set('columns', (configuration.columns ?? []).join(','))
    if (configuration.columnOrder) params.set('columnOrder', configuration.columnOrder.join(','))
    params.set('orderBy', configuration.orderBy)
    params.set('orderByDirection', configuration.orderByDirection)
    const location = configuration.location_id ?? currentLocation
    if (location != null) params.set('location_id', String(location))
    return `${path}?${params}`
}

// Only carry concrete locations between screens; aggregate filters belong to their table.
export function navigationLocationId(requestedLocation, userLocationId, isAdmin) {
    if (!isAdmin) return 1
    return /^[1-9]\d*$/.test(String(requestedLocation))
        ? requestedLocation
        : userLocationId ?? 1
}
